<div class="bg-neutral-primary-soft block p-4 border border-default rounded shadow-xs">
  <ng-content select="header"></ng-content>

  <ng-content></ng-content>
</div>
